import { useDispatch, useSelector } from "react-redux";
import { downloadAntiMnyLndCommExcel } from "../thunks/downloadReportExcel";
import React from "react";
import { StoreType } from "../../../../core/store/reducers";
import { FetchStateType } from "../../../models";

export const useAntiMnyLndCommExcelDownloader = () => {
  const fetchState = useSelector<StoreType, FetchStateType>(
    (s) => s.data.reports.antiLaundering.downloadReportFetchState
  );
  const dispatch = useDispatch();
  const download = React.useCallback(
    () => dispatch(downloadAntiMnyLndCommExcel()),
    [dispatch]
  );

  return [download, fetchState] as [typeof download, typeof fetchState];
};
